module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-BookItalic.e10d4b42.eot";